import cn from "classnames";
import { isExportPngViewOpenAtom } from "frontend/app-header/left-header/atoms/left-header-atoms";
import { useHeaderContext } from "frontend/context/header-context";
import Modal from "frontend/modal/modal";
import ModalContainer from "frontend/modals/modal-container";
import { Box } from "frontend/ui-components/design-system/box/box";
import { RadioButton, RadioButtonGroup } from "frontend/ui-components/radio-button/radio-button";
import { useSetAtom } from "jotai";
import { useState } from "react";
import { ExportButton } from "./export-button";
import styles from "./export-view.module.css";

export const ExportPngView = () => {
  const setIsExportPdfViewOpen = useSetAtom(isExportPngViewOpenAtom);
  const [quality, setQuality] = useState<"low" | "high" | "ultra">("high");
  const { onExport } = useHeaderContext();
  const [isExporting, setIsExporting] = useState(false);

  const onCloseModal = () => {
    setIsExportPdfViewOpen(false);
  };

  const onExportClick = () => {
    setIsExporting(true);
    try {
      onExport(false, {
        format: "image",
        quality,
        singlePage: true,
        frames: [],
        whiteBackground: true,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsExporting(false);
      setIsExportPdfViewOpen(false);
    }
  };

  return (
    <Modal dimBackground onDismissOnEscape={onCloseModal} onClickBackground={onCloseModal} theme="cim-dark">
      <ModalContainer onDismiss={onCloseModal} showCloseButton>
        <Box className={cn(styles.baseModal, styles.pngContent)}>
          <div className={cn(styles.title, styles.pngTitle)}>Export as PNG</div>

          <RadioButtonGroup
            name="export-pdf"
            onChange={(value) => setQuality(value as "low" | "high" | "ultra")}
            classes={{ group: { gap: "20px", marginBottom: "20px" } }}
          >
            <RadioButton value="low" label="Low" initialChecked={true} />
            <RadioButton value="high" label="High" />
            <RadioButton value="ultra" label="Ultra" />
          </RadioButtonGroup>

          <ExportButton onClick={onExportClick} isExporting={isExporting} />
        </Box>
      </ModalContainer>
    </Modal>
  );
};
